import React, { useState, useEffect } from "react";
import { Col, Row, Spin } from "antd";
import LineDashTabLeft from "./LineDashTabLeft";
import LineDashTabRight from "./LineDashTabRight";
import Header from "./Hearder/Header";
// import { Dash, cp1, LineDetails } from "../data/dash";

// import axios from "../../utils/BasicAuthAPI";
import { deepEqualLineDashValues } from "../../utils/CustomFunc";
import { LoadingOutlined } from "@ant-design/icons";
import IntervalCounter from "./IntervalCounter";
import "../../App.css";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import liracrypt from "../../components/Liracrypt/liracrypt";

function LoadComponentV({ selectedLid }) {
  const [settings, setsettings] = useState(null);
  const [settingValues, setsettingValues] = useState(null);
  const [lineDetails, setlineDetails] = useState(null);
  const [compliance, setcompliance] = useState(null);
  const [loaded, setloaded] = useState(false);
  const [loginError, setloginError] = useState(false);
  const [variableData, setVariableData] = useState(null);

  const [target, setTarget] = useState(null);
  const [actual, setActual] = useState(null);
  const [difference, setDifference] = useState(null);
  const [rank, setRank] = useState(null);

  const [dBlock, setDBlock] = useState(null);
  const [mini, setMini] = useState(null);
  const [mainG, setMainG] = useState(null);
  const [aux, setAux] = useState(null);

  const [flipInterval, setFlipInterval] = useState(null);

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  useEffect(() => {
    setInterval(() => {
      liracrypt
        .get("/linedash/linedashvariabledata", {
          lid: selectedLid,
          proj: "all",
        })
        .then(({ data }) => {
          // console.log(data.data);
          setTarget(data.data["lD_ShiftPerf_Tgt"]);
          setActual(data.data["lD_ShiftPerf_Actual"]);
          setDifference(data.data["lD_ShiftPerf_Diff"]);
          setRank(data.data["lD_LineRank_Main"]);
          setMainG(data.data["lD_MainGauge"]);
          const temp = {};
          Object.keys(data.data).forEach((key) => {
            if (key.includes("lD_DataBlock")) {
              temp[key] = data.data[key];
            }
          });

          const gtemp = {};
          Object.keys(data.data).forEach((key) => {
            if (key.includes("lD_MicroGauge")) {
              gtemp[key] = data.data[key];
            }
          });

          setMini(gtemp);
          setDBlock(temp);
          setVariableData(data);
          setsettingValues(data.data);
        })
        .catch(function (error) {
          // console.log("Error****:", error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setloginError(true);
            }
          }
        });
    }, 10000);
  }, []);

  useEffect(() => {
    Promise.all([
      liracrypt.get("/linedash/linedashuiconfig/tabview", {}),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: selectedLid,
        proj: "all",
      }),
      liracrypt.get("/linedash/linedashfixeddata", {
        lid: selectedLid,
      }),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: selectedLid,
        proj: "compliance",
      }),
    ]).then(([lineDashLoad, lineDashValues, lineDetails, compliance]) => {
      setcompliance(compliance.data.data["compliance"]);
      setsettingValues(lineDashValues.data.data);
      setlineDetails(lineDetails.data.config);
      setsettings(lineDashLoad.data.data);
      setAux(lineDashLoad.data.data.auxMenu);
      setFlipInterval(
        lineDashLoad.data.data.ldDataBlockFlipInterval
          ? lineDashLoad.data.data.ldDataBlockFlipInterval
          : 10000
      );
      setloaded(true);
    });

    return () => {
      //   clearInterval(inter);
    };
  }, []);

  // console.log(
  //   settings,
  //   settingValues,
  //   loaded,
  //   rank,
  //   actual,
  //   target,
  //   difference,
  //   dBlock,
  //   mainG,
  //   mini
  // );

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {settings !== null &&
        settingValues !== null &&
        loaded === true &&
        mini &&
        dBlock &&
        compliance ? (
          <div
            className="dash"
            style={{
              // backgroundColor: settings.ld_main[
              //   "background-color"
              // ],
              // backgroundColor: "rgb(29, 29, 29)",
              // height: "100vh",
              overflow: "hidden",
              position: "fixed",
            }}
          >
            <div>
              <Row>
                <Col span={10}>
                  {mini ? (
                    <LineDashTabLeft
                      lid={selectedLid}
                      settings={settings}
                      Actual={actual}
                      Diff={difference}
                      Target={target}
                      Rank={rank}
                      mini={mini}
                      dBlock={dBlock}
                      mainG={mainG}
                      settingValues={{
                        ...settingValues,
                        // ld_PartDet_Img: lineDetails[
                        //   "ld_PartDet_Img"
                        // ],
                        ld_PartDet_pno: lineDetails["ld_PartDet_pno"],
                        ld_PartDet_Pname: lineDetails["ld_PartDet_Pname"],
                        ld_PartDet_Cust: lineDetails["ld_PartDet_Cust"],
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </Col>
                <Col
                  span={13}
                  // style={{
                  //   minHeight: "100%",
                  //   display: "flex",
                  //   justifyContent: "center",
                  //   alignItems: "center",
                  // }}
                >
                  {dBlock && compliance && mini ? (
                    <LineDashTabRight
                      settings={settings}
                      settingValues={{
                        ...settingValues,
                        ...lineDetails,
                      }}
                      dBlock={dBlock}
                      compliance={compliance}
                      selectedLid={selectedLid}
                      mini={mini}
                      flipInterval={flipInterval}
                      aux={aux}
                    />
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div className="Loading">
            <Spin indicator={antIcon} />
          </div>
        )}
      </React.Fragment>
    </>
  );
}

export default LoadComponentV;
